import React from 'react';
import { GENDER_OPTIONS } from '../../../constants/formConstants';

/**
 * Patient information fields component
 * Renders first name, last name, DOB, gender, and postal code
 */
const PatientFields = ({
  formData,
  onChange,
}) => {
  return (
    <>
      <div>
        <label>
          Patient External ID:
          <input
            type="text"
            name="patientExternalId"
            value={formData.patientExternalId}
            onChange={onChange}
            placeholder="External ID"
          />
        </label>
      </div>

      <div>
        <label>
          Enter the first name of the patient:
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={onChange}
            required
          />
        </label>
      </div>

      <div>
        <label>
          Enter the last name of the patient:
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={onChange}
            required
          />
        </label>
      </div>

      <div>
        <label>
          Enter the date of birth (mm/dd/yyyy):
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={onChange}
            required
          />
        </label>
      </div>

      <div style={{ display: 'flex', gap: '16px' }}>
        <div style={{ flex: 1 }}>
          <label>
            Gender:
            <select
              name="gender"
              value={formData.gender}
              onChange={onChange}
              required
            >
              <option value="">Select Gender</option>
              {GENDER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div style={{ flex: 1 }}>
          <label>
            Zipcode:
            <input
              type="text"
              name="postalCode"
              value={formData.postalCode}
              onChange={onChange}
              pattern="[0-9]{5}"
              placeholder="12345"
              required
            />
          </label>
        </div>
      </div>
    </>
  );
};

export default PatientFields;
